"use client";

import CategoryCard from "@/components/custom/category-card";
import { motion } from "motion/react";

interface Category {
  readonly key: string;
  readonly image: string;
  readonly description: string;
}

interface CategoriesGridProps {
  categories: readonly Category[];
}

export default function CategoriesGrid({ categories }: CategoriesGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
      {categories.map((category, index) => (
        <motion.div
          key={category.key}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{
            duration: 0.4,
            delay: Math.min(index * 0.05, 0.3),
            ease: "easeOut"
          }}
        >
          <CategoryCard
            name={category.key}
            category={category.key}
            imageUrl={category.image}
            description={category.description}
            imageSize="large"
          />
        </motion.div>
      ))}
    </div>
  );
}
